/**
 * @description Directory for ID Attributes on Case Builder Issuer.
 * Naming Convention: "[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "mainlayout-btn-cancel".
 */
const idDirectory = {
    caseBuilderIssuer: {
        divRoot: `caseBuilderIssuer-div-root`,
        divTopbar: `caseBuilderIssuer-div-topbar`,
        divTopbarTitle: `caseBuilderIssuer-div-topbarTitle`,
        divTopbarClose: `caseBuilderIssuer-div-topbarClose`,
        iconClose: `caseBuilderIssuer-icon-close`,
        divMain: `caseBuilderIssuer-div-main`,
        divActions: `caseBuilderIssuer-div-actions`,
        btnBack: `caseBuilderIssuer-btn-back`,
        btnsaveDraft: `caseBuilderIssuer-btn-saveDraft`,
        btnSaveContinue: `caseBuilderIssuer-btn-saveContinue`,
    },

}

export default idDirectory
